<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <CidadaoEndereco
            :data-atual="form.cidadao.dataAtual"
            :disable-filters="model.classificacaoId === enums.classificacao.MUNICIPE || model.classificacaoId === enums.classificacao.PROVISORIO"
            :form="form.cidadao.endereco"
            :isResponsavel="form.isResponsavel"
            :isPermissaoEndereco="form.isPermissaoEndereco"
            :model="model.cidadao"
            :termos-invalidos="form.cidadao.termosInvalidos"
            :saidaCidadaoId="model.saidaCidadaoId"
            :origem="'cadastroPaciente'"
            @setFieldsDomicilio="setFieldsDomicilio"
            @alterResponsavel="alterResponsavel"
            @limpar-informacoes-sociais="limparInformacoesSociais"
        />
    </rkm-form>
</template>

<script>
// Components.
import CidadaoEndereco from '@/components/cadastro/cidadao/Endereco'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

export default {
    components: { CidadaoEndereco },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        enums: { classificacao },
    }),
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        limparInformacoesSociais() {

            this.$emit('limpar-informacoes-sociais');
        },
        setFieldsDomicilio(data) {

            this.resetFields()
            this.form.residentes = data.residentes

            const dados = data.informacaoResidencial

            if (dados) {

                this.form.domicilioId = dados.domicilioId ?? null

                this.model.imovelTipoId = dados.imovelTipoId ?? null
                this.model.situacaoDomicilioId = dados.situacaoDomicilioId ?? null
                this.model.domicilioTipoId = dados.domicilioTipoId ?? null
                this.model.quantidadeComodos = dados.quantidadeComodos ?? null
                this.model.situacaoRuralId = dados.situacaoRuralId ?? null
                this.model.domicilioZonaId = dados.domicilioZonaId ?? null
                this.model.domicilioTipoAcessoId = dados.domicilioTipoAcessoId ?? null
                this.model.materialPredominanteId = dados.materialPredominanteId ?? null
                this.model.abastecimentoId = dados.abastecimentoId ?? null
                this.model.tratamentoId = dados.tratamentoId ?? null
                this.model.destinoLixoId = dados.destinoLixoId ?? null
                this.model.formaEscoamentoId = dados.formaEscoamentoId ?? null
                this.model.possuiAnimais = dados.possuiAnimais ?? null
                this.model.energiaEletrica = dados.energiaEletrica ?? null
                this.model.quantidadeAnimais = dados.quantidadeAnimais ?? null
                this.model.animal = dados.newAnimal ?? []
                this.model.instituicaoNome = dados.instituicaoNome ?? null
                this.model.instituicaoOutrosProfissionais = dados.instituicaoOutrosProfissionais ?? null
                this.model.instituicaoNomeResponsavelTecnico = dados.instituicaoNomeResponsavelTecnico ?? null
                this.model.instituicaoCnsResponsavelTecnico = dados.instituicaoCnsResponsavelTecnico ?? null
                this.model.instituicaoCargoResponsavelTecnico = dados.instituicaoCargoResponsavelTecnico ?? null
                this.model.instituicaoTelefoneResponsavelTecnico = dados.instituicaoTelefoneResponsavelTecnico ?? null
                this.model.escalaCoelhoId = dados.escalaCoelhoId ?? null
                this.model.higieneResidencialId = dados.higieneResidencialId ?? null
                this.model.bolsaFamilia = dados.bolsaFamilia ?? null
                this.model.valeGas = dados.valeGas ?? null
                this.model.bolsaEscola = dados.bolsaEscola ?? null
                this.model.lazer = dados.newLazer ?? []
                this.model.foraArea = dados.foraArea ?? null
                this.model.microareaId = dados.microareaId ?? null
            }
        },
        resetFields() {

            this.form.domicilioId = null

            this.model.imovelTipoId = null
            this.model.situacaoDomicilioId = null
            this.model.domicilioTipoId = null
            this.model.quantidadeComodos = null
            this.model.situacaoRuralId = null
            this.model.domicilioZonaId = null
            this.model.domicilioTipoAcessoId = null
            this.model.materialPredominanteId = null
            this.model.abastecimentoId = null
            this.model.tratamentoId = null
            this.model.destinoLixoId = null
            this.model.formaEscoamentoId = null
            this.model.possuiAnimais = null
            this.model.energiaEletrica = null
            this.model.quantidadeAnimais = null
            this.model.animal = []
            this.model.instituicaoNome = null
            this.model.instituicaoOutrosProfissionais = null
            this.model.instituicaoNomeResponsavelTecnico = null
            this.model.instituicaoCnsResponsavelTecnico = null
            this.model.instituicaoCargoResponsavelTecnico = null
            this.model.instituicaoTelefoneResponsavelTecnico = null
            this.model.escalaCoelhoId = null
            this.model.higieneResidencialId = null
            this.model.bolsaFamilia = null
            this.model.valeGas = null
            this.model.bolsaEscola = null
            this.model.lazer = []
            this.model.foraArea = null
            this.model.microareaId = null
        },
        alterResponsavel(value) {
            this.model.alteraResponsavel = value
        }
    }
}
</script>